module.exports = __webpack_public_path__ + "img/网站3-36.62177f32.png";